module.exports = __webpack_public_path__ + "img/gyoza_dipping.a10cb160.jpg";